var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M19.996 30.846l12.388-12.479a6.006 6.006 0 0 0 1.759-4.278 5.957 5.957 0 0 0-1.745-4.255 6.037 6.037 0 0 0-4.35-1.811c-1.661 0-3.197.644-4.36 1.82l-3.677 3.714-2.691-2.718-1.002-1.012A6.087 6.087 0 0 0 11.95 8a6.056 6.056 0 0 0-4.344 1.812 5.962 5.962 0 0 0-1.75 4.265c0 1.6.617 3.097 1.767 4.259l12.372 12.51zm8.052-26.823a9.823 9.823 0 0 1 7.044 2.948A10.03 10.03 0 0 1 38 14.1c0 2.693-1.038 5.224-2.924 7.13L20.714 35.7c-.2.2-.465.301-.726.301-.258 0-.526-.108-.725-.308L4.931 21.2A10.065 10.065 0 0 1 2 14.077a10.028 10.028 0 0 1 2.915-7.13A9.842 9.842 0 0 1 11.951 4a9.873 9.873 0 0 1 7.06 2.963l1 1.01.985-.995a9.85 9.85 0 0 1 7.052-2.955z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favs.c0b99165d2e9018b09d6020149f5bda4.svg";